export const comparePriceData = [
  {
    id: 1,
    image:
      'https://wise.com/public-resources/assets/logos/wise-personal/logo.svg',
    rate: {
      amount: '4.56406',
      status: 'good',
      type: 'Mid-market rate',
      ref: 'https://wise.com/gb/mid-market-rate'
    },
    fee: {
      amount: '6.27 GBP',
      type: 'Transparent fee',
      ref: 'https://wise.com/gb/pricing/send-money?sourceAmount=1000&sourceCcy=GBP&targetCcy=EUR&tab=0'
    },
    recipientGets: {
      amount: '4,535.44 AED'
    }
  },
  {
    id: 2,
    image: 'https://dq8dwmysp7hk1.cloudfront.net/logos/remitly.svg',
    rate: {
      amount: '4.56406',
      status: 'bad'
    },
    fee: {
      amount: '6.27 GBP'
    },
    recipientGets: {
      amount: '4,535.44 AED',
      info: '-4.93 EUR',
      warning:
        'This data shows the cost of sending GBP from your account, to EUR in Germany. But bear in mind that this provider could charge differently depending on the country you’re sending to.'
    }
  },
  {
    id: 3,
    image: 'https://dq8dwmysp7hk1.cloudfront.net/logos/monese.svg',
    rate: {
      amount: '4.56406',
      status: 'good',
      type: 'Mid-market rate',
      ref: 'https://wise.com/gb/mid-market-rate'
    },
    fee: {
      amount: '6.27 GBP'
    },
    recipientGets: {
      amount: '4,535.44 AED',
      info: '-4.93 EUR'
    }
  },
  {
    id: 4,
    image: 'https://dq8dwmysp7hk1.cloudfront.net/logos/moneygram.svg',
    rate: {
      amount: '1.12493',
      status: 'bad'
    },
    fee: {
      amount: '0.00 GBP'
    },
    recipientGets: {
      amount: '4,535.44 AED',
      info: '-4.93 EUR'
    }
  },
  {
    id: 5,
    image:
      'https://wise.com/public-resources/assets/logos/wise-personal/logo.svg',
    rate: {
      amount: '4.56406',
      status: 'good',
      type: 'Mid-market rate',
      ref: 'https://wise.com/gb/mid-market-rate'
    },
    fee: {
      amount: '6.27 GBP',
      type: 'Transparent fee',
      ref: 'https://wise.com/gb/pricing/send-money?sourceAmount=1000&sourceCcy=GBP&targetCcy=EUR&tab=0'
    },
    recipientGets: {
      amount: '4,535.44 AED'
    }
  },
  {
    id: 6,
    image: 'https://dq8dwmysp7hk1.cloudfront.net/logos/remitly.svg',
    rate: {
      amount: '4.56406',
      status: 'bad'
    },
    fee: {
      amount: '6.27 GBP'
    },
    recipientGets: {
      amount: '4,535.44 AED',
      info: '-4.93 EUR',
      warning:
        'This data shows the cost of sending GBP from your account, to EUR in Germany. But bear in mind that this provider could charge differently depending on the country you’re sending to.'
    }
  },
  {
    id: 7,
    image: 'https://dq8dwmysp7hk1.cloudfront.net/logos/monese.svg',
    rate: {
      amount: '4.56406',
      status: 'good',
      type: 'Mid-market rate',
      ref: 'https://wise.com/gb/mid-market-rate'
    },
    fee: {
      amount: '6.27 GBP'
    },
    recipientGets: {
      amount: '4,535.44 AED',
      info: '-4.93 EUR'
    }
  },
  {
    id: 8,
    image: 'https://dq8dwmysp7hk1.cloudfront.net/logos/moneygram.svg',
    rate: {
      amount: '1.12493',
      status: 'bad'
    },
    fee: {
      amount: '0.00 GBP'
    },
    recipientGets: {
      amount: '4,535.44 AED',
      info: '-4.93 EUR'
    }
  }
];
